import * as React from 'react'
import * as style from './index.module.css'

interface Props {
  /** タイトル */
  readonly title: string
  /** 概要 */
  readonly discription: string
}

/**
 * @file  `value`の共通components
 */
export const Value = ({ title, discription }: Props): React.JSX.Element => {
  return (
    <div className={style.root}>
      <h4 className={style.title}>{title}</h4>
      <p className={style.discription}>{discription}</p>
    </div>
  )
}
